import { ValidatorFn } from '@angular/forms';
import { ProfileFormField } from './profile-form.types';
import { parseIntWithDefaultNull } from 'src/app/shared/util/parse-int-with-default-null';

export const maxCertValidityRequiredValidator: ValidatorFn = group => {
  const unitControls = [
    ProfileFormField.maxCertificateValidityYears,
    ProfileFormField.maxCertificateValidityMonths,
    ProfileFormField.maxCertificateValidityDays,
  ].map(path => group.get(path));
  const anyContainsNumber = unitControls.some(
    c => parseIntWithDefaultNull(c?.value) !== null,
  );

  if (anyContainsNumber) {
    return null;
  }
  return { maxCertValidityRequired: true };
};

export const atLeastOneCertValidity: ValidatorFn = group => {
  const controls = [
    group.get(ProfileFormField.maxCertificateValidityDays),
    group.get(ProfileFormField.maxCertificateValidityMonths),
    group.get(ProfileFormField.maxCertificateValidityYears),
  ];

  if (controls.some(control => control?.untouched)) {
    return null;
  }

  const total = controls.reduce(
    (sum, control) => sum + Number(control?.value ?? 0),
    0,
  );

  const error = total > 0 ? null : { allZero: true };

  return error;
};
